function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShopify = function SvgShopify(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 50 50",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 13.3c0-.2-.2-.3-.3-.3h-2.9s-2.3-2.2-2.5-2.4-.5-.2-.8-.1l-1.1.3c-.1-.5-.3-.9-.5-1.3-.6-1.5-2-2.4-3.5-2.5h-.3l-.1-.1c-.6-.7-1.5-1-2.4-1-1.8 0-3.7 1.4-5.2 3.8-1 1.6-1.7 3.5-2.1 5.4l-3.6 1.1c-1.1.3-1.1.4-1.2 1.4C11 18.4 8.2 40 8.2 40l23.4 4.1 10.2-2.5c0-.1-4.1-28.1-4.2-28.3m-8.8-2.2-1.8.6c0-1.1-.2-2.3-.6-3.4 1.4.3 2.1 1.9 2.4 2.8m-3 1-3.9 1.2c.3-1.4 1-2.7 2-3.8.4-.4.8-.7 1.3-1q.6 1.65.6 3.6m-2.6-4.9c.4 0 .8.1 1.1.3-.5.3-1 .7-1.4 1.1-1.2 1.5-2.1 3.2-2.4 5.1l-3.2 1c.6-3 3.1-7.4 5.9-7.5",
    style: {
      fill: "#95bf47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3 13h-2.9s-2.3-2.2-2.5-2.4c-.1-.1-.2-.1-.3-.1v33.7l10.2-2.5s-4.1-28-4.2-28.2c0-.4-.1-.5-.3-.5",
    style: {
      fill: "#5e8e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 18.2-1.2 4.4c-.9-.4-1.9-.5-2.9-.5-2.3.1-2.3 1.6-2.3 2 .1 2 5.3 2.4 5.6 7 .2 3.6-1.9 6.1-5 6.3-2.1.2-4.2-.5-5.8-2l.8-3.4c1.1.8 2.4 1.3 3.7 1.5.8 0 1.4-.7 1.4-1.5v-.1c-.2-2.6-4.4-2.4-4.7-6.7-.2-3.6 2.1-7.2 7.3-7.5 1.1 0 2.1.1 3.1.5",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShopify);
export default ForwardRef;